import Geolocation from '../utils/Geolocation';
import intlTelInput from 'intl-tel-input';

/**
 * Populates the cities selector depending on the selected country.
 */
const populateCitiesByCountry = (country, el) => {
  new Geolocation(country).cities().then( cities => {
    cities.forEach( city => {
      el.appendChild(new Option(city.print_name, city.name));
    });
  });
};

// PHONE NUMBER AREA CODE
const areasTelephone = input => {
 let current = intlTelInput(input);
 if (input.value === "") {
  input.value = `+${current.selectedCountryData.dialCode}`;
 }
 changeCountryCode(input, current);
};

const changeCountryCode = (input, code) => {
  input.addEventListener("countrychange", () => input.value = `+${code.selectedCountryData.dialCode}`)
}

/**
 * Attach a change event listener to the given country selectbox. The listener handles loading
 * the cities of the country selected.
 * @param {HTMLElement} el country select box
 */
const attachCountryChangeHandler = el => {
  // eslint-disable-next-line no-unused-expressions
  el && el.addEventListener('change', evt => {
    const parentContainer = evt.target.closest('.js-expert-profile__locations');
    const currentIndex = parentContainer.dataset.index;
    const citySelector = document.getElementById(`expert_profile_expert_profile_locations_attributes_${currentIndex}_city`);
    citySelector.length = 0; // to remove all existing cities
    citySelector.disabled = false;
    populateCitiesByCountry(el.value, citySelector);
  });
};

/**
 * Attach a new DOM element so the user can add a new location. This function should
 * be trigger by the add new location button on the UI.
 */
const addLocation = () => {
  const locations = document.querySelectorAll('.js-expert-profile__locations');
  const lastLocation = locations[locations.length - 1];
  const lastIndex = parseInt(lastLocation.dataset.index, 10);

  // the new location will have the following index of the list
  const newIndex = lastIndex + 1;

  // we clone the last element but with a new index and modify the childs
  const newLocation = lastLocation.cloneNode(true);
  const fieldName = 'expert_profile_locations_attributes';
  newLocation.dataset.index = newIndex;
  ['country', 'city', 'street', 'phone'].forEach(el => {
    const formEl = newLocation.querySelector(`.js-expert-profile__${el}`);
    // modify the element
    formEl.setAttribute('id', `expert_profile_${fieldName}_${newIndex}_${el}`);
    formEl.setAttribute('name', `expert_profile[${fieldName}][${newIndex}][${el}]`);
    formEl.value = null; // clear any value the element of the form has
    if (el === 'phone') {
      areasTelephone(formEl); // activate telephone input
    }
  });

  // now we add the new location
  lastLocation.parentNode.appendChild(newLocation);

  // to finish, we attach the country handler
  attachCountryChangeHandler(newLocation.querySelector('.js-expert-profile__country'));
};

export { addLocation, attachCountryChangeHandler, areasTelephone };
